import { render, staticRenderFns } from "./mainPageBanner.vue?vue&type=template&id=5d0d4d62&scoped=true&"
import script from "./mainPageBanner.vue?vue&type=script&lang=js&"
export * from "./mainPageBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d4d62",
  null
  
)

export default component.exports